import service from '../index';

// 登录
export function getLogin(data) {
    return service({
        url: '/api/loginController/phoneRegister',
        method: 'POST',
        data:data,
    });
};
// 获取项目列表
export function getManageList(data) {
    return service({
        url: '/api/ManageListController/getManageList',
        method: 'POST',
        data:data,
    });
};

// 保存企业信息
export function saveComInfo(data) {
    return service({
        url: '/api/AttestationController/saveComInfo',
        method: 'POST',
        data:data,
    });
};
// 获取企业信息
export function getComInfo() {
    return service({
        url: '/api/AttestationController/getComInfo',
        method: 'POST',
        data:{
            userName:window.sessionStorage.getItem("username"),
            phoneNum:window.sessionStorage.getItem("phoneNum"),
            from:"33",
        },
    });
};

// 自助申请保存订单
export function makeOrder(data) {
    return service({
        url: '/api/OfflineOrderController/makeOrder',
        method: 'POST',
        data:data
    });
};

// 自助申请保存订单
export function MakeOrderController(data) {
    return service({
        url: '/api/MakeOrderController/makeOrder',
        method: 'POST',
        data:data
    });
};
// 保存支付接口
export function goPay(data) {
    return service({
        url: '/api/MakeOrderController/goPay',
        method: 'POST',
        data:{
            orderId:data.orderId,
            comCode:data.comCode,
            bankSerial:data.bankSerial,
            absolutePath: data.absolutePath,
            bankName: data.bankName,
            accountName: data.accountName,
            accountNum:data.accountNum
        }
    });
};
// 安诚保险保存支付接口
export function goAnPay(data) {
    return service({
        url: '/api/MakeOrderController/goPayJt',
        method: 'POST',
        data:{
            orderId:data.orderId,
            comCode:data.comCode,
            bankSerial:data.bankSerial,
            absolutePath: data.absolutePath,
            bankName: data.bankName,
            accountName: data.accountName,
            accountNum: data.accountNum,
            bidValidity:data.bidValidity,
        }
    });
};

// 根据项目id回显项目信息
export function pickManage() {
    return service({
        url: '/api/MakeOrderController/pickManage',
        method: 'POST',
        data:{
            userId:Number(window.sessionStorage.getItem("userId")),
            manageId:Number(window.sessionStorage.getItem("manageId")),
        }
    });
};

// 获取订单列表
export function getOrderList(data) {
    return service({
        url: '/api/OrderListController/getOrderList',
        method: 'POST',
        data:data
    });
};

// 展示营业执照接口
export function showFile() {
    return service({
        url: '/api/MakeOrderController/showFile',
        method: 'GET',
        params:{
            orderId:Number(window.sessionStorage.getItem("orderId")),
            fileType:1
        }
    });
};

// 下载保函
export function getGuaranteeUrl(data) {
    return service({
        url: '/api/OrderListController/getGuaranteeUrl',
        method: 'POST',
        data:{
            userId:window.sessionStorage.getItem("userId"),
            insuranceId:data,
        }
    });
};
// 大家下载保函
export function getDaGuaranteeUrl(data) {
    return service({
        url: `/api/OrderListController/getDjcGuarantee/${data}`,
        method: 'POST',
    });
};

// 获取退保列表
export function getRefundList(data) {
    return service({
        url: '/api/RefundOrderController/getRefundList',
        method: 'POST',
        data:data,
    });
};

// 退保查看详情
export function getDetailedRefund(data) {
    return service({
        url: '/api/RefundOrderController/getDetailedRefundInfo',
        method: 'POST',
        data:data,
    });
};


// 获取发票列表
export function getInvoiceOrderList(data) {
    return service({
        url: '/api/InvoiceListController/getInvoiceOrderList',
        method: 'POST',
        data:data,
    });
};

// 申请发票接口
export function applyInfoice(data) {
    return service({
        url: '/api/InvoiceListController/applyInvoice',
        method: 'POST',
        data:data,
    });
};

// 获取发票明细列表
export function getInvoiceList(data) {
    return service({
        url: '/api/InvoiceListController/getInvoiceList',
        method: 'POST',
        data:data,
    });
};

// 获取发票详情
export function getDetailedInvoiceInfo(data) {
    return service({
        url: '/api/InvoiceListController/getDetailedInvoiceInfo',
        method: 'POST',
        data:data,
    });
};

// 保存开票信息
export function saveCompanyInvoiceInfo(data) {
    return service({
        url: '/api/InvoiceListController/saveCompanyInvoiceInfo',
        method: 'POST',
        data:data,
    });
};

// 修改开票信息
export function updateInvoiceInfo(data) {
    return service({
        url: '/api/InvoiceListController/updateInvoiceInfo',
        method: 'POST',
        data:data,
    });
};

// 重置密码接口
export function findPassWord(data) {
    return service({
        url: '/api/loginController/findPassWord',
        method: 'POST',
        data:data,
    });
};

// 申请退保接口
export function goRefund(data) {
    return service({
        url: '/api/RefundOrderController/goRefund',
        method: 'POST',
        data:data,
    });
};

// 获取企业发票信息
export function getInvoiceCompanyInfo(data) {
    return service({
        url: '/api/InvoiceListController/getInvoiceCompanyInfo',
        method: 'POST',
        data:data,
    });
};


// 检查用户开票信息是否完善
export function checkInvoiceInfo(data) {
    return service({
        url: '/api/InvoiceListController/checkInvoiceInfo',
        method: 'POST',
        data:data,
    });
};
// 退保验证码
export function tuicode(data) {
    return service({
        url: '/api/loginController/getRCode',
        method: 'POST',
        data:data,
    });
};
// 保险公司
export function insuranceList(data) {
    return service({
        url: '/api/OrderListController/insuranceCompanyManagementList',
        method: 'POST',
        data:data,
    });
};